// import api from "@/api";

import axios from "@/axios";

const getters = {
    dataset(state) {
        return state.dataset;
    },
};

const state = {
    dataset: false,
};

export const SET_DATASET = "setDataset";
const mutations = {
    [SET_DATASET](state, payload) {
        state.dataset = payload;
    },
};

export const GET_DATASET = "getDataset";
const actions = {
    [GET_DATASET](context) {
        return new Promise((resolve, reject) => {
            axios
                .post("/dataset.active", {
                    token: context.getters.token,
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((data) => {
                    reject(data.response);
                });
        });
    },
};

export default {
    getters,
    state,
    mutations,
    actions,
};
